import styled from 'styled-components';
import { windowMaxWidth } from './breakpoints';

const UploaderWrapper = styled.div`
  margin-bottom: 10px;
`;

const UploaderHeader = styled.div`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-bottom: 10px;
`;

const Title = styled.div`
  color: var(--greyscale-blackish);
  font-size: var(--font-size-heading-3);
  font-weight: var(--font-weight-medium);
  line-height: var(--font-line-height-medium);
  margin-right: 8px;
`;

const Description = styled.div`
  color: var(--greyscale-shade);
  font-size: var(--font-size-regular);
  line-height: var(--font-line-height-regular);
  margin-bottom: 10px;
  max-width: 70%;

  @media (${windowMaxWidth.splitScreen}) {
    max-width: 100%;
  }
`;

const FlexWrapper = styled.div`
  align-items: center;
  display: flex;

  @media (${windowMaxWidth.mobile}) {
    flex: auto;
    justify-content: space-between;
  }
`;

const ButtonWrapper = styled.div`
  display: flex;
  justify-content: flex-end;

  svg {
    path:last-child {
      fill: var(--primary-oqio-blue);
    }
  }

  @media (${windowMaxWidth.mobile}) {
    display: none;
  }
`;

const ContentWrapper = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  margin-top: 30px;
`;

const ContentRightWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  gap: 20px;
`;

const DropzoneWrapper = styled.div`
  background-color: var(--greyscale-white);
  border: 2px dashed var(--primary-oqio-blue);
  border-radius: var(--border-radius-small);
  cursor: pointer;
  display: flex;
  justify-content: center;
  min-height: 70px;
  padding: 10px;
  transition:
    border 0.2s ease-in,
    box-shadow 0.2s ease-out;

  &:hover {
    background-color: var(--greyscale-porcelain);
  }

  &:active {
    background-color: #f0f0f0;
  }

  &:focus {
    outline: none;
  }

  &:hover,
  &:active,
  &:focus {
    border-color: var(--primary-oqio-blue);
  }

  ${({ $isDisabled }) =>
    $isDisabled &&
    `
    cursor: default;
    border-color: var(--greyscale-concrete) !important;
    background-color: var(--greyscale-porcelain) !important;

    span{
      color: var(--greyscale-concrete) !important;
    }
  `}

  ${({ $hasError }) =>
    $hasError &&
    `
    border-color: var(--primary-oqio-red) !important;
  `}
`;

const DropzoneTextWrapper = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  font-weight: var(--font-weight-regular);
  justify-content: center;
`;

const HighlightedText = styled.span`
  color: var(--primary-oqio-blue);
  font-weight: var(--font-weight-medium);
  text-decoration: underline;
`;

const DropzoneText = styled.span``;

const CompactSpinner = styled.div`
  .ant-spin {
    padding: 0 !important;
  }
`;

export const InlineUploaderLayout = {
  UploaderWrapper,
  UploaderHeader,
  Title,
  Description,
  FlexWrapper,
  ButtonWrapper,
  ContentWrapper,
  ContentRightWrapper,
  DropzoneWrapper,
  DropzoneTextWrapper,
  DropzoneText,
  HighlightedText,
  CompactSpinner
};
